import { Box, Flex, Text } from "@chakra-ui/layout";
import { ReactNode } from "react";

const DashboardCardWithHeader = ({
	header,
	direction = "column",
	children,
	px,
}: {
	header: string;
	children: ReactNode;
	direction?: "column" | "row";
	px?: string;
}) => {
	return (
		<Box w="100%" border="solid 1px" borderColor="gray.300" borderRadius="xl">
			<Box borderBottom="solid 1px" borderColor="gray.300" p="16px">
				<Text
					lineHeight="30px"
					fontSize="20px"
					fontWeight="600"
					color="gray.800"
				>
					{header}
				</Text>
			</Box>
			<Flex
				py="16px"
				px={px}
				w="100%"
				justify="center"
				alignItems="center"
				direction={direction}
			>
				{children}
			</Flex>
		</Box>
	);
};

export default DashboardCardWithHeader;
